import React, { Component } from "react";
import Data from "../../config/data";
import ScrollView from "./ScrollView";
import Content from "./Content";

export default class NewEraPrivacy extends Component {

    render() {
        const data = Data.newEraPrivacy;
        return (
            <ScrollView>
                <Content data={data} />
            </ScrollView>
        );
    }

}


// WEBPACK FOOTER //
// ./src/component/newEra/newEraPrivacy.js